(function ($) {
  "use strict";

  function scrollToSection(id) {
    const $targetSection = $(`.js-section-residential-details-frontpage[id="${id}"]`);
    if ($targetSection.length) {
      $(".js-section-residential-details-frontpage.active").removeClass("active");
      $targetSection.addClass("active");
      const headerHeight = $("header").height();
      const targetOffset = $targetSection.offset().top - headerHeight;
      $("html, body").animate({ scrollTop: targetOffset }, 200);
    }
  }

  function checkHashOnLoad() {
    const hash = window.location.hash;
    if (hash.length > 0) {
      const hashContent = hash.substring(1);
      if (hashContent.startsWith('!')) {
        const fullId = hashContent.substring(1);
        if (fullId.startsWith('residential-')) {
          const id = fullId.substring(12);
          scrollToSection(id);
        }
      }
    }
  }

  function initResidentialDetailsFrontpageSlider() {
    const residentialSlider = document.querySelectorAll(".js-residential-details-frontpage-slider");
    const prevArrow = document.querySelectorAll(".js-residential-frontpage-slider-prev");
    const nextArrow = document.querySelectorAll(".js-residential-frontpage-slider-next");
    const thumbnailSlider = document.querySelectorAll(".js-residential-details-thumbnail-slider");

    residentialSlider.forEach((slider, index) => {
      let thumbSwiper = null;
      if (thumbnailSlider[index]) {
        thumbSwiper = new Swiper(thumbnailSlider[index], {
          spaceBetween: 10,
          slidesPerView: 4,
          freeMode: true,
          watchSlidesProgress: true,
          breakpoints: {
            320: {
              slidesPerView: 3,
              spaceBetween: 8
            },
            768: {
              slidesPerView: 4,
              spaceBetween: 10
            },
            1024: {
              slidesPerView: 5,
              spaceBetween: 12
            }
          }
        });
      }

      const mainSwiper = new Swiper(slider, {
        spaceBetween: 8,
        slidesPerView: 1.3,
        navigation: {
          nextEl: nextArrow[index],
          prevEl: prevArrow[index],
        },
        thumbs: {
          swiper: thumbSwiper,
        },
        breakpoints: {
          992: {
            slidesPerView: 1,
            spaceBetween: 10
          },
        }
      });
    });
  }

  $(function () {
    $(".js-m-residential__card--details").on("click", function () {
      const id = $(this).data("id");
      const hashBang = `!#residential-${id}`;
      if (history.pushState) {
        history.pushState(null, null, hashBang);
      } else {
        window.location.hash = hashBang;
      }
      scrollToSection(id);
    });

    checkHashOnLoad();

    if ($(".js-residential-details-frontpage-slider").length) {
      initResidentialDetailsFrontpageSlider();
    }
  });
})(jQuery);
